import { apiRequest } from "../_core/apiRequest";

export async function listAuthAccounts() {
  return apiRequest({
    method: "GET",
    path: "/auth/accounts",
    auth: true,
    authorizationToken: "id",
    includeAccountContext: false,
    errorMessage: "Não foi possível carregar suas contas.",
  });
}

export async function selectAuthAccount(accountId) {
  return apiRequest({
    method: "POST",
    path: "/auth/accounts/select",
    data: { account_id: accountId },
    auth: true,
    authorizationToken: "id",
    includeAccountContext: false,
    errorMessage: "Não foi possível acessar esta conta.",
  });
}
